import { parse } from 'date-fns';
import { validateCalcDecimalNumber, validateUSDCurrencyValue } from "../../inputValidation";
import { formatCurrency, formatTime } from "../Number";
export const operationsMethods = {
  add: (a, b) => parseFloat(a) + parseFloat(b),
  subtract: (a, b) => parseFloat(a) - parseFloat(b),
  multiply: (a, b) => parseFloat(a) * parseFloat(b),
  divide: (a, b) => parseFloat(a) / parseFloat(b)
};
const msToHours = msNumber => {
  const minPerHour = 60;
  const secPerMin = 60;
  const msPerSec = 1000;
  return msNumber / msPerSec / secPerMin / minPerHour;
};
const timeFormats = {
  0: 'HH:mm',
  1: 'hh:mm a',
  2: 'HH:mm:ss',
  3: 'mm:ss'
};
const getFormatter = ({
  type,
  style = 0
}) => {
  if (type === 'Time') {
    const timeFormat = timeFormats[style];
    const today = new Date(Date.UTC(0, 0, 0, 0, 0, 0)).setHours(0, 0, 0, 0);
    return value => {
      const parsedValue = msToHours(parse(value, timeFormat, today) - today);
      return Number.isNaN(parsedValue) ? value : parsedValue;
    };
  }
  if (type === 'Date') {
    return value => {
      const dateTime = new Date(Date.parse(value)).getTime();
      return Number.isNaN(dateTime) ? value : dateTime / (1000 * 60 * 60);
    };
  }

  // TODO: This handles the currency formatting, but it's not great.
  // Think we may benefit from createing an abstracted out "BuilderNumber" wrapper
  // that we can use to handle formatting, value parseing etc.
  return value => parseFloat(`${value}`.replace(/[\$,\,]/g, ''));
};
export const performOperation = (operation, firstValue, secondValue) => {
  const {
    operation_type
  } = operation;
  const operationMethod = operationsMethods[operation_type];
  return operationMethod(firstValue.value, secondValue.value);
};
export const CalculationValue = entry => {
  const {
    value,
    type,
    default: defaultValue
  } = entry;
  const rawValue = value || defaultValue || 0;
  const formatter = getFormatter(entry);
  const formattedValue = formatter(rawValue);
  return {
    rawValue,
    type,
    value: formattedValue
  };
};

/*
Extra rules Per Matt Warner:
  here are two things going on after the calculation is completed

  the first is IF:
    a. the total is less than 0
    b. one of the operands in the the calculation is a time field
    c. all the operands in the calculation is a time field

    then add 24 to the result (basically this is making the assumption that you saw where the second time field is the next day)

  the second is IF:
    a. the total is less than 0
    b. one of the operands in the the calculation is a time field
    c. the style of the current field (the calculation) is > 0

    then multiple by -1 (making the result positive) we never show a -15:00  or anything like that, we only show negatives when the result is a number
*/

const applyCalculationTweaks = (value, calculationEntries, style = 0) => {
  const timeFields = calculationEntries.filter(({
    entry
  }) => entry.type === 'Time');
  const allFieldsAreTimeFields = timeFields.length === calculationEntries.length;
  if (value < 0 && timeFields && allFieldsAreTimeFields) {
    return value + 24;
  }
  if (value < 0 && timeFields && style > 0) {
    return value * -1;
  }
  return value;
};
export const calculate = (entries, operations, style = 0) => {
  const calculationEntries = operations.map(operation => {
    const entry = entries.find(({
      guid,
      parentGuid = guid
    }) => parentGuid === operation.parentEntryGuid);
    if (entry) {
      return {
        ...operation,
        entry: CalculationValue(entry)
      };
    } else {
      return {
        ...operation,
        entry: CalculationValue({
          value: operation.value,
          type: 'Constant'
        })
      };
    }
  }).filter(exists => exists);
  const applyOperation = (previous, operation) => {
    const operationValue = performOperation(operation, previous, operation.entry);
    return CalculationValue({
      value: operationValue,
      type: operation.entry.type
    });
  };
  const calculatedValue = calculationEntries.reduce(applyOperation, CalculationValue({
    value: 0,
    type: 'Number'
  }));
  return applyCalculationTweaks(calculatedValue.value, calculationEntries, style);
};
export const formatValue = (calculation, style, mask) => {
  const value = Number.isNaN(calculation) ? 0 : calculation;
  switch (style) {
    case 0:
      const parsedMask = parseInt(mask);
      const decimalValue = value.toFixed(parsedMask) || value;
      return validateCalcDecimalNumber(decimalValue) ? decimalValue : 0 .toFixed(parsedMask) || 0;
    case 1:
    case 2:
    case 3:
      return formatTime(style, calculation);
    case 4:
      const currencyValue = formatCurrency(value.toFixed(2));
      return validateUSDCurrencyValue(currencyValue) ? currencyValue : formatCurrency('0.00');
    default:
      return value;
  }
};